<template>
  <BaseDeleteCautionConfirmModal
    :is-open="attributes.opened"
    :is-loading="attributes.loading"
    :data-testid="attributes.testId"
    :custom-class="attributes.customClass"
    :type="attributes.type"
    :title="attributes.title"
    :button-label="attributes.buttonLabel"
    @confirm-action="handleDiscardChangesModalConfirm"
    @close-modal="handleDiscardChangesModalClose"
  >
    <template #content>
      <p v-dompurify-html="content" class="sb-modal-header__subtitle" />
    </template>
  </BaseDeleteCautionConfirmModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DOMPurify from 'dompurify'
import { ALLOWED_TAGS } from '@/constants/allowedTags'
import BaseDeleteCautionConfirmModal from '@base/BaseDeleteCautionConfirmModal/BaseDeleteCautionConfirmModal.vue'

export default defineComponent({
  components: {
    BaseDeleteCautionConfirmModal,
  },

  props: {
    attributes: {
      type: Object,
      required: true,
    },
  },

  emits: ['close-modal', 'confirm-modal'],

  computed: {
    content() {
      return DOMPurify.sanitize(this.attributes.content, {
        ALLOWED_TAGS,
      })
    },
  },

  created() {
    this.handleConfirmModalByPressingEnter()
  },

  unmounted() {
    window.removeEventListener('keydown', this.pressEnterEventCallback)
  },

  methods: {
    pressEnterEventCallback(e) {
      if (e.key === 'Enter') {
        this.handleDiscardChangesModalConfirm()
      }
    },

    handleDiscardChangesModalClose() {
      this.$emit('close-modal')
    },

    handleDiscardChangesModalConfirm() {
      this.$emit('confirm-modal')
    },

    handleConfirmModalByPressingEnter() {
      window.addEventListener('keydown', this.pressEnterEventCallback)
    },
  },
})
</script>
